import React, { useState } from 'react';

import CloseCaseInfo from '../CloseCaseInfo/CloseCaseInfo';

import moment from 'moment';

import { Case, CloseReason } from '../../../interfaces/Patient';
import CloseCaseForm from '../CloseCaseForm/CloseCaseForm';
import useHttp from '../../../hooks/useHttp';
import { getEnvironmentApiUrl } from '../../../services/General';
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

interface Props {
    caso: Case
    closeModal: () => void
    updateCase: (body: Partial<Case>) => void
}

const CloseCaseDialog: React.FC<Props> = ({ caso, closeModal, updateCase }) => {

    const [endDate, setEndDate] = useState<moment.Moment | null>(moment());

    const [showEndingInfo, setShowEndingInfo] = useState(false);

    const [closureReason, setClosureReason] = useState<CloseReason | null>(null);

    const { sendRequest } = useHttp();

    const handleContinue = () => {
        setShowEndingInfo(true);
    };

    const handleConfirm = () => {
        if (closureReason === null || endDate === null) return;
        const newCaseBody = {
            case_closure_reason_id: closureReason.id,
            end_date: endDate.toISOString(),
            case_id: caso.id
        };
        sendRequest({
            url: getEnvironmentApiUrl() + 'case/close_case',
            method: 'POST',
            body: newCaseBody
        }, () => {
            updateCase(newCaseBody);
            closeModal();
        });
    };

    return (
        <>
            {showEndingInfo && closureReason ?
                <div className='dialog'>
                    <CloseCaseInfo
                        caso={caso}
                        closureReason={closureReason}
                    />
                    <CancelConfirmButtons
                        onCancel={closeModal}
                        onConfirm={handleConfirm}
                    />
                </div>
                :
                <CloseCaseForm
                    endDate={endDate}
                    changeEndDate={(d) => setEndDate(d)}
                    closureReason={closureReason}
                    changeClosureReason={(r) => setClosureReason(r)}
                    handleContinue={handleContinue}
                />
            }
        </>
    );
};

export default CloseCaseDialog;